import React from 'react'

const ProcedureStatusInfo = ({item_code_type, partNumber, status, revision, partDescription}) => {
  return <>
    {/* Procedure Header Information */}
      <div style={{ marginBottom:"30px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
          <tr>
            <td style={{ width: "70%", fontSize: "20px" }}>
              <div>
              <strong>
                {item_code_type} {partNumber}
              </strong>
              </div>
            </td>
            <td style={{ width: "15%" }}>
              <strong>Status:</strong>{" "}
              <span style={{ color: "gray" }}>{status || "Draft"}</span>
            </td>
            <td style={{ width: "15%", textAlign: "right" }}>
              <strong>Revision:</strong> {revision}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
  </>
}

export default ProcedureStatusInfo
